import type { ChangeEvent } from 'react';
import { Checkbox as LibCheckbox } from 'qampo-ui-library';
import styles from './Checkbox.module.css';

interface CheckboxProps {
  // The library puts this id on the wrapping label and looks it up with
  // getElementById to tint the tick, so it must be unique on the page.
  id: string;
  isChecked: boolean;
  onChange: (isChecked: boolean) => void;
  // Always required: it is the checkbox's accessible name. Pass
  // isLabelHidden when the column header already carries the visible text.
  label: string;
  isLabelHidden?: boolean;
  isDisabled?: boolean;
}

/**
 * qampo-ui-library's Checkbox styled with this project's design tokens. The
 * library component reads a few tokens under names this project does not use,
 * which leaves a ticked box looking like a plain filled square (see
 * Checkbox.module.css). Wrapping it keeps that patch in one place and gives
 * every checkbox an accessible name, which the raw grid inputs it replaces
 * lacked.
 */
export const Checkbox = ({
  id,
  isChecked,
  onChange,
  label,
  isLabelHidden,
  isDisabled
}: CheckboxProps) => (
  <LibCheckbox
    id={id}
    check={isChecked}
    disable={isDisabled}
    onChange={(e: ChangeEvent<HTMLInputElement>) => onChange(e.target.checked)}
    text={label}
    labelClasses={styles.label}
    classes={styles.checkmark}
    checkBoxTextClasses={isLabelHidden ? 'visuallyHidden' : styles.text}
  />
);
